import { supabase } from './supabase-client';

/**
 * Download an image through the watermark proxy edge function.
 * Applies user's watermark settings automatically.
 */
export async function downloadImageWithWatermarks(
  imageUrl: string,
  filename: string,
): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) {
    // Fallback to direct download if no session
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = filename;
    link.click();
    return;
  }

  const proxyUrl = new URL(
    `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/download-image`
  );
  proxyUrl.searchParams.set('url', imageUrl);
  proxyUrl.searchParams.set('format', 'jpg');
  proxyUrl.searchParams.set('filename', filename);
  proxyUrl.searchParams.set('applyWyskoWatermark', 'true');
  proxyUrl.searchParams.set('applyAgencyWatermark', 'true');

  const response = await fetch(proxyUrl.toString(), {
    method: 'GET',
    headers: { 'Authorization': `Bearer ${session.access_token}` },
  });

  if (!response.ok) {
    throw new Error(`Download failed: ${response.statusText}`);
  }

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
}
